<template>
  <div>Indicadores Aps</div>
</template>

<script>
export default {}
</script>

<style></style>
